import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = 'api/v1/writer'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  add(writer) {
    return http.post(`${resource}`, writer)
  },
  edit(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  get(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  update(writer, uuid) {
    return http.put(`${resource}/${uuid}`, writer)
  },
  destroy(uuid) {
    return http.delete(`${resource}/${uuid}`)
  },
}
